import { useNavigate } from "react-router-dom";
import styles from "./avaliacaoDesempenho.module.css";
import BottomNav from "../../components/BottomNav";

export default function AvaliacaoDesempenho() {
    const navigate = useNavigate();

    function abrirLink(url) {
        if (!url) return;
        window.open(url, "_blank");
    }

    // TODO: substituir "rota" pelos links reais de cada avaliação
    const menus = [
        {
            titulo: "Faça sua Avaliação",
            descricao: "Responda sua avaliação de desempenho.",
            icone: "📝",
            rota: "/avaliacao-desempenho/avaliacoes",
            interno: true
        },
        {
            titulo: "Relatórios das Avaliações",
            descricao: "Consulte os relatórios das avaliações realizadas.",
            icone: "📊",
            rota: ""
        },
        {
            titulo: "Relatórios das Avaliações(IOS)",
            descricao: "Versão dos relatórios para dispositivos iOS.",
            icone: "📱",
            rota: ""
        },
        {
            titulo: "Período de Experiência",
            descricao: "Acompanhe as avaliações do período de experiência.",
            icone: "📅",
            rota: ""
        },
    ];

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div className={styles.headerIcon}>📈</div>
                <div className={styles.headerTexto}>
                    <h2>Avaliação de Desempenho</h2>
                    <p>Acesse as avaliações de desempenho</p>
                </div>
            </div>

            <div className={styles.grid}>
                {menus.map((item, index) => (
                    <div
                        key={index}
                        className={styles.card}
                        onClick={() => item.interno ? navigate(item.rota) : abrirLink(item.rota)}
                    >
                        <div className={styles.icon}>{item.icone}</div>

                        <div className={styles.info}>
                            <h4>{item.titulo}</h4>
                            <span>{item.descricao}</span>
                        </div>

                        <div className={styles.arrow}>›</div>
                    </div>
                ))}
            </div>
            <BottomNav />
        </div>
    );
}
